import { Injectable } from '@angular/core';
import { CommonService } from '../../../common/common.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { JsonPipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ExportPdfService {

  constructor(
    public http : HttpClient
  ) { }

  private extractData(res: Response) {
    let body = res;
    return body || {};
  }

  /* exportPdf(payload, token): Observable<any> {
    let url = CommonService.BASE_URL + '/api/v1/secure/export-pdf';
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + token
      })
    }
    return this.http.put(url, payload, httpOptions)
      .pipe(
        map(response => {
          console.log(response);
        }),
        catchError(error => {
          if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
          } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
              `Backend returned code ${error.status}, ` +
              `body was: ${error.error}`);
            if (error.status === 403) {
              window.dispatchEvent(new CustomEvent('user:force-logout'));
            }
          }
          // return an observable with a user-facing error message
          return throwError(
            'Something bad happened; please try again later.');
        })
      );
  } */

  exportPdf(payload, token): Promise<any> {
    let url = CommonService.BASE_URL + '/api/v1/secure/export-pdf';
    const options = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify(payload)
    };
    return fetch(url, options)
      .then(response => {
        console.log('Response With fetch()' +  JSON.stringify(response));
        if (response.status === 200) {
          return response.blob();
        } else {
          return null;
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}
